import resume from '../assets/pdf/litepaperv2.pdf'
import one from '../assets/svg/svguri/profile.png'

export const headerData = {
    name: 'eBuds',
    title: "Decentralized Autonomous Community",
    desciption:"In a world that is controlled by central authorities, eBudsDAC mission is to create a decentralized platform that is driven by the community and powered by the people.",
    image: one,
    resumePdf: resume
}
